import axios from 'axios';
import { CLIENT_LIST } from '../../constants';

export const fetchClientList = (data, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadClientList());

  axios
    .post(`/client/listClient`, data, config)
    .then((res) => dispatch(setClientList(res)))
    .catch((err) => {
      dispatch(errorClientList(err.response));
      onError(err.response);
    });
};

export const loadClientList = () => ({
  type: CLIENT_LIST.LOAD,
});

export const setClientList = (userList) => ({
  type: CLIENT_LIST.SUCCESS,
  payload: userList.data.data,
});

export const errorClientList = (error) => ({
  type: CLIENT_LIST.FAIL,
  payload: error,
});
